module.exports = __webpack_public_path__ + "static/media/lv.bbb1f42f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/countriesFlags/lv.svg
// module id = 1457
// module chunks = 0